import config from "@/../config";
import router from "@/router";

export default new (class AuthenticationHelper {
  realm = "";

  getRealm = () => {
    const splitedPath = location.pathname.split("/");
    if (splitedPath && splitedPath[1]) {
      return splitedPath[1];
    } else {
      return config.value("VUE_APP_REALM");
    }
  };

  setRealmFromUrl = () => {
    this.realm = this.getRealm();
  };

  addRealmToRoutes = () => {
    for (const route of router.getRoutes()) {
      router.removeRoute(route.name);
      let newRoute = route;
      newRoute.path = "/" + this.realm + route.path;
      router.addRoute(newRoute);
      if (route.name == "base") {
        newRoute.path = route.path;
        newRoute.name = "default_base";
        router.addRoute(newRoute);
      }
    }
  };

  install = (app) => {
    this.setRealmFromUrl();
    this.addRealmToRoutes();
    app.config.globalProperties.$realm = this.realm;
  };
})();
